import { EventType } from 'constants/enums'
import { ModelCard } from '..'
import { CarComparisonStore } from '../store'
import { TrimSelectorCheckbox } from './trim-selector-checkbox'

/**
 * Trim Selector modal component
 */
export class TrimSelectorModel extends TrimSelectorCheckbox {
    protected get myPicksLength(): number {
        return CarComparisonStore.getInstance().get().length
    }

    public constructor(id: string) {
        super(id)
    }

    /**
     * Bind event listeners
     */
    protected bindListeners(): void {
        this.compareButton.addEventListener(EventType.CLICK, () => {
            // disable compare button on find compare page
            this.modelCard.disableCompare()
            this.addToMyPicks()
        })
        super.bindListeners()
    }

    /**
     * Add to MyPicks
     */
    public addToMyPicks(): void {
        this.checkedItems.forEach(async (vehicleId) => {
            void CarComparisonStore.getInstance().add(vehicleId)
        })
        super.addToMyPicks()
    }

    /**
     * Open Trim Selector modal
     * Replace the model information and fetch trims from API
     *
     * @param {string} image Image URL
     * @param {number} year
     * @param {string} make
     * @param {string} model
     */
    public async openTrimSelector(modelCard: ModelCard): Promise<void> {
        this.modelCard = modelCard
        void this.handleTrimSelector(modelCard)
    }
}
